import Hero from "../components/Hero";
import { Link } from "react-router-dom";
import ImageFeature from "../components/ImageFeature";
import VideoCard from "../components/VideoCard";
import FeatureGrid from "../components/section-templates/FeatureGrid";
import VideoGridSection from "../components/section-templates/VideoGridSection";
export default function Home() {
  const VideosThinkmarkets = [
    {
      title: "15 year anniversary of ThinkMarkets",
      src: "https://www.youtube.com/watch?v=qrxsG_7DPPQ",
      description: "Anniversary celebration of TM. Awareness campaign.",
      tags: ["After Effects", "Blender", "Premiere", "Audition"],
    },
    {
      title: "Appstore / Playstore Animation",
      src: "https://www.youtube.com/watch?v=aA--1k1lrcM",
      description: "AppStore and Playstore trailer.",
      tags: ["Blender", "After Effects"],
    },
    {
      title: "ThinkTrader Promo",
      src: "https://www.youtube.com/watch?v=-9xs_PJr3_E",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "Dynamic Leverage Explainer",
      src: "https://www.youtube.com/watch?v=2z35kyfPBus",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "BTC Halving Explainer",
      src: "https://www.youtube.com/watch?v=VIF5bGccNgk",
      description: "Explaining the Bitcoin halving event.",
      tags: ["Premiere Pro", "After Effects", "Photoshop", "Illustrator"],
    },
    {
      title: "TM X TV Promo",
      src: "https://www.youtube.com/watch?v=TxjO_5Ij93w",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
  ];

  const VideosHoody = [
    {
      title: "Hype Beta Launch",
      src: "https://youtu.be/D2ILZCLLdlY",
      description: "The video’s ultimate goal was to announce the beta launch.",
      tags: [
        "After Effects",
        "Blender",
        "Premiere",
        "Audition",
        "Unreal Engine",
      ],
    },
    {
      title: "Project V [Hoody] [002",
      src: "https://youtu.be/fPQbKxcHCN4",
      description: "A test version that I did as well.",
      tags: ["Blender", "After Effects"],
    },
  ];

  const VideosCointelegraph = [
    {
      title: "NT Discord Promo",
      src: "https://youtu.be/_NwgFmTH4OM",
      description: "A promotional video for the Nitro's Network discord server",
      tags: ["After Effects", "Blender"],
    },

    {
      title: "Nitro Bots [Unfinished]",
      src: "https://youtu.be/6z8ZG0-raPA",
      description: "A promotional video for the Nitro's Network discord server",
      tags: ["After Effects", "Blender"],
    },
    {
      title: "NT Website Launch ",
      src: "https://youtu.be/CUBxlavD2CA",
      description: "A promo video for NT's website launch",
      tags: ["Blender", "After Effects"],
    },

    {
      title: "NT Visual Test Project ",
      src: "https://youtu.be/ljXNPnDciHs",
      description: "A promo video for NT's website launch",
      tags: ["After Effects"],
    },

    {
      title: "Snoop Dogg's NFT Promo ",
      src: "https://youtu.be/WVoTaloNsLU",
      description: "A promo for Snoop Dogg's NFT collection",
      tags: ["After Effects"],
    },
    {
      title: "Animal's Concert X Snoop Dogg x Billy Ray Cyrus ",
      src: "https://youtu.be/n3uy8BtyyhQ",
      description: "Teaser for Animal's concerts. ",
      tags: ["After Effects", "Unreal Engine", "Blender"],
    },
  ];

  const VideosFreelance = [
    {
      title: "SiteGround's Test Video",
      src: "https://youtu.be/qI7KRGc0FDs",
      description: "Explainer video",
      tags: ["After Effects"],
    },
    {
      title: "NFTpay",
      src: "https://youtu.be/MbqMHrlqHDQ",
      description: "Explainer video",
      tags: ["After Effects"],
    },
    {
      title: "Kickstarter Board Game Video 1",
      src: "https://youtu.be/O_qgFX0bO4s?si=9sF47xO8LtuEoDVG",
      description: "Teaser",
      tags: ["After Effects", "Blender"],
    },
    {
      title: "Kickstarter Board Game Video 2",
      src: "https://www.youtube.com/watch?v=2rdXxZpDraY",
      description: "Teaser",
      tags: ["After Effects", "Blender"],
    },

    {
      title: "Helpshift's Explainer Video",
      src: "https://youtu.be/NOsikwaawNg",
      description: "Explainer video",
      tags: ["After Effects"],
    },
    {
      title: "Hashtag Expert for IG",
      src: "https://youtu.be/Z0oaSqDj5pg",
      description: "Teaser",
      tags: ["After Effects"],
    },
    {
      title: "Danielle Walker's Promo",
      src: "https://youtu.be/czJ4joskkto",
      description: "At some point I was editing most of Danielle's videos.",
      tags: ["After Effects"],
    },
    {
      title: "The Daily Wire Promo",
      src: "https://youtu.be/efI85yTkLCA",
      description:
        "I was editing some of TDW's content, during my time at ImagineContent.",
      tags: ["After Effects"],
    },
  ];
  return (
    <>
      <Hero
        title="Portfolio"
        subtitle="A showcase of my work in motion design and animation."
        // subtitle="Here you can find some of my work."
        mediaType="video"
        mediaSrc="../assets/hero-video-particles-2.webm"
      >
        <div className="hero-buttons">
          {/* <Link to="/personal" className="hero-button-primary custom-style">
            Personal
          </Link> */}
        </div>
      </Hero>

      {/* ———————————————————————————————— */}
      <div className="experience-banner container">
        <span className="exp-line" />
        <span className="exp-text">where pixels come to life</span>
        <span className="exp-line" />
      </div>
      {/* ———————————————————————————————— */}

      {/* <VideoGallery /> */}
      <div className="container">
        <h1 className=" section-title">Showreel ‘23 Q4</h1>
        <p>2023 - Today: Bringing ideas to life through animation</p>
      </div>
      <div className="container">
        <VideoCard
          tags={[
            "Motion Design",
            "After Effects",
            "Premiere Pro",
            "Blender",
            "Mogrpah",
          ]}
          // title={"Work at ThinkMarkets"}
          // description="Here you will find some of my most recent projects that I've created for ThinkMarkets."
          src="https://youtu.be/EKQsyVQKRlg"
        />
      </div>

      <div className="container">
        <h1 className=" section-title">Corporate Projects</h1>
        <p>A snapshot of my professional journey.</p>
      </div>

      <FeatureGrid>
        <ImageFeature
          href="/projects/work-at-thinkmarkets"
          imageSrc="/assets/Images/Portfolio/banners/thinkmarkets-banner.webp"
          imageAlt="my-contribution-at-thinkmarkets"
          title="My contribution @ThinkMarkets"
          description="2024 - Currently working"
        />

        <ImageFeature
          href="/projects/work-at-hoody"
          imageSrc="/assets/Images/Portfolio/banners/hoody-banner.webp"
          imageAlt="my-contribution-at-hoody"
          title="My contribution @Hoody"
          description="Sep 2023 – Nov 2023 (On-site)"
        />

        <ImageFeature
          href="/projects/work-at-cointelegraph"
          imageSrc="/assets/Images/Portfolio/banners/cointelegraph-banner.webp"
          imageAlt="my-contribution-at-cointelegraph"
          title="My contribution @Cointelegraph "
          description="Mar 2022 – Jan 2023 (Full-remote)"
        />
      </FeatureGrid>

      <VideoGridSection
        title="Videos @ThinkMarkets"
        description="A showcase of my work at ThinkMarkets, including explainer videos, promotional content, and more."
        videos={VideosThinkmarkets}
      />
      <VideoGridSection
        title="Videos @Hoody"
        description="A couple of the videos at Hoody that I worked on."
        videos={VideosHoody}
      />

      <VideoGridSection
        title="Videos @Cointelegraph"
        description="Some of the more fun projects from my time at Cointelegraph."
        videos={VideosCointelegraph}
      />

      <VideoGridSection
        title="Freelance Projects"
        description="A small collection with some of my more interesting freelance projects."
        videos={VideosFreelance}
      />
    </>
  );
}
